// Keep established form validation, authentication and transaction flows.
export const routeAliases = {
  '/m/deposit':'/deposit', '/m/withdraw':'/withdraw',
  '/m/records':'/bets-history', '/m/securityCenter':'/securityCenter',
  '/m/support':'/customer-support',
};
